import { useEffect, useRef } from 'react';

/** Resets state when the user switches to a different project, but not on initial mount. */
export function useResetOnProjectChange(
  projectId: string | undefined,
  reset: () => void,
) {
  const previousProjectIdRef = useRef<string | undefined>(projectId);
  const resetRef = useRef(reset);
  resetRef.current = reset;

  useEffect(() => {
    const previousProjectId = previousProjectIdRef.current;
    if (previousProjectId !== undefined && previousProjectId !== projectId) {
      resetRef.current();
    }
    previousProjectIdRef.current = projectId;
  }, [projectId]);
}
